import { useEffect } from 'react';
import { checkAvailability } from 'services/voucherService';
import { useAppContext } from 'context/app';
import { useHistory } from 'react-router-dom';
import { constants } from 'utils';

export default function useAvailable() {
  const history = useHistory();
  const { actions } = useAppContext();

  useEffect(() => {
    async function checkAvailable() {
      const { status, startTime } = await checkAvailability();
      actions.updateAvailability(status, startTime);
      if (status === 'TECHNICAL_ERROR') {
        history.push(constants.Routes.TechnicalError);
      } else if (status !== 'SUCCESS') {
        history.push(constants.Routes.Home);
      }
    }

    checkAvailable();
  }, [actions, history]);
}
